import { Button, Group, Modal, Select, Space, TextInput } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFilter, IconFilterCancel } from "@tabler/icons-react";
import { ChangeEvent, useCallback, useState } from "react";

export interface FiltroIdeia {
  search: string;
  campo: string;
  status: string;
}

const mockFilter: FiltroIdeia = {
  search: "",
  campo: "",
  status: ""
};

const camposDisponiveis = ["Título", "Autor(es)", "E-mail", "Regulamento"];

const statusDisponiveis = [
  { value: "", label: "Todos os status" },
  { value: "NOVA_IDEIA", label: "Nova Ideia" },
  { value: "AGUARDANDO_ANALISE_DO_COMITE", label: "Aguardando Análise do Comitê" },
  { value: "PRE_ANALISE", label: "Pré-análise" },
  { value: "EM_ANALISE_DE_VIABILIDADE", label: "Em Análise de Viabilidade" },
  { value: "RASCUNHO", label: "Rascunho" },
  { value: "APROVADA", label: "Aprovada" },
  { value: "REPROVADA", label: "Reprovada" },
  { value: "IMPLEMENTADA", label: "Implementada" },
  { value: "CANCELADA", label: "Cancelada" },
  { value: "EM_IMPLEMENTACAO", label: "Em Implementação" },
  { value: "BACKLOG_DE_AVALIACAO_FUTURA", label: "Backlog de Avaliação Futura" }
];

interface ModalFilterIdeiasProperties {
  setFilter: React.Dispatch<React.SetStateAction<FiltroIdeia>>;
}

const ModalFilterIdeias = ({ setFilter }: ModalFilterIdeiasProperties) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [values, setValues] = useState<FiltroIdeia>(mockFilter);

  const clearFiltro = useCallback(() => {
    setFilter(mockFilter);
    setValues(mockFilter);
  }, [setFilter]);

  const applyFilter = useCallback(() => {
    setFilter(values);
    setValues(mockFilter);
    close();
  }, [setFilter, close, values]);

  const changeInput = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setValues((values) => ({ ...values, search: event.target.value }));
  }, []);

  const changeCampo = useCallback((campo: string | null) => {
    setValues((values) => ({ ...values, campo: campo || "" }));
  }, []);

  const changeStatus = useCallback((status: string | null) => {
    setValues((values) => ({ ...values, status: status || "" }));
  }, []);

  return (
    <>
      <Button variant="transparent" p="0px">
        <IconFilter onClick={open} />
      </Button>
      <Button variant="transparent" onClick={clearFiltro} p="0px">
        <IconFilterCancel />
      </Button>

      <Modal opened={opened} onClose={close} title="Filtrar Ideias">
        <Select
          label="Campo a ser filtrado"
          placeholder="Selecione um campo..."
          data={camposDisponiveis}
          value={values.campo}
          onChange={changeCampo}
          clearable
        />

        <Space h="md" />

        <TextInput
          label="Texto a ser procurado"
          placeholder="Digite o texto para buscar..."
          value={values.search}
          onChange={changeInput}
        />

        <Space h="md" />

        <Select
          label="Status da ideia"
          placeholder="Selecione um status..."
          data={statusDisponiveis}
          value={values.status}
          onChange={changeStatus}
          clearable
        />

        <Space h="xl" />

        <Group justify="flex-end">
          <Button variant="transparent" onClick={close}>
            Cancelar
          </Button>
          <Button variant="filled" onClick={applyFilter}>
            Filtrar
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ModalFilterIdeias;
